import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { getSubscriptionBannerContent } from '../../utils/clinicSubscriptionAccess';

const toneStyles = {
  indigo: 'bg-indigo-50 border-indigo-200 text-indigo-950',
  amber: 'bg-amber-50 border-amber-200 text-amber-950',
};

function dismissKey(userData, clinicData) {
  const id = userData?.uid || clinicData?.clinicId || 'anon';
  return `subscriptionBannerDismissed_${id}`;
}

export default function SubscriptionAccessBanner({ userData, clinicData }) {
  const content = getSubscriptionBannerContent(userData, clinicData);
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    if (!content) {
      setDismissed(true);
      return;
    }
    try {
      setDismissed(sessionStorage.getItem(dismissKey(userData, clinicData)) === 'true');
    } catch {
      setDismissed(false);
    }
  }, [content?.title, userData?.uid, clinicData?.clinicId]);

  if (!content || dismissed) return null;

  const tone = toneStyles[content.tone] || toneStyles.amber;

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(dismissKey(userData, clinicData), 'true');
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div className={`border-b px-4 py-2.5 sm:px-6 ${tone}`}>
      <div className="max-w-5xl mx-auto flex items-start gap-3 sm:items-center sm:justify-between">
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-sm">{content.title}</p>
          <p className="text-sm opacity-90 mt-0.5">{content.message}</p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Link
            to={content.ctaPath}
            className="inline-flex items-center justify-center rounded-lg bg-white/90 px-3 py-1.5 text-xs font-semibold shadow-sm ring-1 ring-inset ring-black/5 hover:bg-white sm:text-sm sm:px-4 sm:py-2"
          >
            {content.ctaLabel}
          </Link>
          <button
            type="button"
            onClick={handleDismiss}
            className="rounded-lg p-1.5 opacity-70 hover:bg-white/80 hover:opacity-100"
            aria-label="Dismiss"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
